import { AuthActionTypes } from './auth.types';

const INITIAL_STATE = {
  currentUser: null,
  authHeader: null,
  priviledge: {},
  pageBeforeLogin: '/',
  isLoggedOut: false
};

const authReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case AuthActionTypes.SET_CURRENT_USER:
      return {
        ...state,
        currentUser: action.payload
      };
    case AuthActionTypes.SET_TOKEN:
      return {
        ...state,
        authHeader: { 'Authorization': 'Bearer ' + action.payload }
      };
    case AuthActionTypes.SET_PRIVILEGE:
      return {
        ...state,
        priviledge: action.payload
      };
    case AuthActionTypes.SET_PAGE_BEFORE_LOGIN:
      return {
        ...state,
        pageBeforeLogin: action.payload
      };
    case AuthActionTypes.SET_LOGOUT_STATE:
      return {
        ...state,
        isLoggedOut: action.payload
      };
    default:
      return state;
  }
};

export default authReducer;